<div>
    <form [formGroup]="inviteCodeForm" (ngSubmit)="onSubmit()">
        <input id="inviteCode" formControlName="code" type="text" placeholder="Enter invite code here">
        <button type="submit">Submit</button>
    </form>
    <div *ngIf="formMessage" class="formMessage">{{ formMessage }}</div>
</div>